import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";
import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import CheckCSName from "../../CheckCSName";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultText from "../ResultText";
import EmptyLine from "../../EmptyLine";

export default function SV4({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

function Description({row, settings, globalVariables}) {
    switch (row.error_id) {
        case MessageCodes.Internal.SV4_SV04.error_id: {
            return (
                <>
                    <ResultText>
                        The culvert rise is not consistent with the survey data at the following {row?.data?.length} culverts.
                    </ResultText>
                    {
                        row?.data?.map(r => {
                            return (
                                <>
                                    <ResultTable maxWidth={HecRasHelper.getWidth(60)}>
                                        <ResultHeader>
                                            <ResultRow>
                                                <ResultHeaderCell colSpan={2} style={{textAlign: 'left', width: HecRasHelper.getWidth(30)}}>Culvert</ResultHeaderCell>
                                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>CULUSCR</ResultHeaderCell>
                                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>CULUSINV</ResultHeaderCell>
                                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Rise</ResultHeaderCell>
                                            </ResultRow>
                                        </ResultHeader>
                                        <ResultBody>
                                            <ResultRow>
                                                <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(20)}} rowSpan={3}>{r.cross_section} Culvert {r?.culvert_num}</ResultBodyCell>
                                                <ResultHeaderCell style={{fontWeight: 'normal', textAlign: 'left', width: HecRasHelper.getWidth(10)}}>US</ResultHeaderCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{r?.culuscr?.toFixed(2)}</ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{r?.culusinv?.toFixed(2)}</ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{r?.rise_us?.toFixed(2)}</ResultBodyCell>
                                            </ResultRow>
                                            <ResultRow>
                                                <ResultHeaderCell style={{fontWeight: 'normal', textAlign: 'left', width: HecRasHelper.getWidth(10)}}>DS</ResultHeaderCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{r?.culdscr?.toFixed(2)}</ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{r?.culdsinv?.toFixed(2)}</ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{r?.rise_ds?.toFixed(2)}</ResultBodyCell>
                                            </ResultRow>
                                            <ResultRow>
                                                <ResultHeaderCell style={{fontWeight: 'normal', textAlign: 'left', width: HecRasHelper.getWidth(10)}}>Model</ResultHeaderCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}></ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}></ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>{r?.model_rise?.toFixed(2)}</ResultBodyCell>
                                            </ResultRow>
                                        </ResultBody>
                                    </ResultTable>
                                    <EmptyLine />
                                </>
                            )
                        })
                    }
                </>
            )
        }
    }
}